import React, { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import StatusToastNotification from '@components/StatusToastNotification';

type Props = {
  status: 'success' | 'error' | null;
  clearStatus: () => void;
  isMobileView: boolean;
};
const ContactStatusToast: FC<Props> = ({
  status,
  clearStatus,
  isMobileView,
}) => {
  const { t } = useTranslation();

  if (!status) return null;

  const commonProps = {
    duration: 8000,
    dismissible: true,
    onDismiss: () => clearStatus(),
  };

  const config = {
    success: {
      dataHook: 'brief-success-message',
      message: t('brief-submit-success-message'),
    },
    error: {
      dataHook: 'brief-error-message',
      message: t('brief-submit-error-message'),
    },
  } as const;
  const toastProps = config[status];

  return (
    <StatusToastNotification
      key={`brief-${status}-message`}
      status={status}
      isMobileView={isMobileView}
      {...commonProps}
      {...toastProps}
    />
  );
};

export default ContactStatusToast;
